import PropTypes from 'prop-types'

import Button from '@/components/Button'
import Card from '@/components/Card'
import SweetAlertError from '@/components/SweetAlertError'
import SweetAlertSuccess from '@/components/SweetAlertSuccess'
import cn from '@/utilities/cn'

import './index.scss'

const ConfirmationCard = ({
  title,
  primaryClick,
  primaryText,
  secondaryClick,
  secondaryText,
  message,
  subMessage,
  modal,
  icon,
  error
}: any) => (
  <section className={cn({ 'card rounded-lg border border-zinc-200 bg-white shadow': !modal, card: !modal })}>
    {!!title && <Card.Header title={title} />}
    <Card.Content>
      <div className="confirmation-card">
        {error ? (
          <SweetAlertError icon={icon} message={message} subMessage={subMessage} />
        ) : (
          <SweetAlertSuccess message={message} subMessage={subMessage} />
        )}
      </div>
    </Card.Content>
    <Card.Footer>
      {!!secondaryText && (
        <Button color="secondary" onClick={secondaryClick}>
          {secondaryText}
        </Button>
      )}
      {!!primaryText && (
        <Button color="primary" onClick={primaryClick}>
          {primaryText}
        </Button>
      )}
    </Card.Footer>
  </section>
)

ConfirmationCard.displayName = 'ConfirmationCard'

ConfirmationCard.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  icon: PropTypes.element,
  modal: PropTypes.bool,
  primaryClick: PropTypes.func,
  primaryText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  secondaryClick: PropTypes.func,
  secondaryText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  subMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  error: PropTypes.bool.isRequired
}

ConfirmationCard.defaultProps = {
  icon: null,
  modal: false,
  title: null,
  primaryText: null,
  primaryClick: () => {},
  secondaryClick: () => {},
  secondaryText: null,
  subMessage: ''
}

export default ConfirmationCard
